import $ from 'jquery'

const $doc = $(document)

function menuDropdownA11y() {
  /*
  Adapted from: An accessible menu for WordPress
  https://github.com/argenteum/accessible-nav-wp
  Licensed GPL v.2 (http://www.gnu.org/licenses/gpl-2.0.html)
  This work derived from:
  https://github.com/WordPress/twentysixteen (GPL v.2)
  https://github.com/wpaccessibility/a11ythemepatterns/tree/master/menu-keyboard-arrow-nav (GPL v.2)
  */

  let menuContainer = $('.js-header');
  let siteHeaderMenu = menuContainer.find('.js-header-wrapper');

  // If you are using WordPress, and do not need to localise your script, or if you are not using WordPress, then uncomment the next line

  let screenReaderText = {"expand":"Expand child menu","collapse":"Collapse child menu"};

  let dropdownToggle = $('<button />', { 'class': 'dropdown-toggle', 'aria-expanded': false })
    .append($('<span />', { 'class': 'u-sr-only', text: screenReaderText.expand }))
    .append($('<i class="icon arrow-down"></i>'))


  // Adds the dropdown toggle button
  $('.nav__list > .menu-item-has-children > a').after(dropdownToggle);

  // Adds arrows to 3rd level nav links
  //$('.nav--main .sub-menu .sub-menu a').prepend('<i class="icon arrow"></i>');

  //change empty a elements to p elements
  $('.nav--main a[href="#"]').each(function(i) {
    const content = this.text;
    $("<p>"+content+"</p>").insertAfter(this)
    this.remove()
  })

  // Adds aria attribute
  siteHeaderMenu.find('.menu-item-has-children').attr('aria-haspopup', 'true');

  // Toggles the sub-menu when dropdown toggle button clicked
  siteHeaderMenu.find('.dropdown-toggle').click(function (e) {

    let screenReaderSpan = $(this).find('.u-sr-only');

    e.preventDefault();
    $(this).toggleClass('toggled-on');
    $(this).nextAll('.sub-menu').toggleClass('toggled-on');

    // jscs:disable
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'false'
      ? 'true' : 'false');
    // jscs:enable
    screenReaderSpan.text(screenReaderSpan.text() ===
      screenReaderText.expand ? screenReaderText.collapse :
      screenReaderText.expand);
  });

  // Adds a class to sub-menus for styling
  $('.sub-menu .menu-item-has-children').parent('.sub-menu').addClass('has-sub-menu');


  // Keyboard navigation
  $('.menu-item a, button.dropdown-toggle').on('keydown', function (e) {

    if ([37, 38, 39, 40].indexOf(e.keyCode) == -1) {
      return;
    }

    switch (e.keyCode) {

      case 37: 				// left key
        e.preventDefault();
        e.stopPropagation();

        if ($(this).hasClass('dropdown-toggle')) {
          $(this).prev('a').focus();
        }
        else {

          if ($(this).parent().prev().children('button.dropdown-toggle').length) {
            $(this).parent().prev().children('button.dropdown-toggle').focus();
          }
          else {
            $(this).parent().prev().children('a').focus();
          }
        }

        if ($(this).is('ul ul ul.sub-menu.toggled-on li:first-child a')) {
          $(this).parents('ul.sub-menu.toggled-on li').children('button.dropdown-toggle').focus();
        }

        break;

      case 39: 				// right key
        e.preventDefault();
        e.stopPropagation();

        if ($(this).next('button.dropdown-toggle').length) {
          $(this).next('button.dropdown-toggle').focus();
        }
        else {
          $(this).parent().next().children('a').focus();
        }

        if ($(this).is('ul.sub-menu .dropdown-toggle.toggled-on')) {
          $(this).parent().find('ul.sub-menu li:first-child a').focus();
        }

        break;


      case 40: 				// down key
        e.preventDefault();
        e.stopPropagation();

        if ($(this).next().length) {
          $(this).next().find('li:first-child a').first().focus();
        }
        else {
          $(this).parent().next().children('a').focus();
        }

        if (($(this).is('ul.sub-menu a')) && ($(this).next('button.dropdown-toggle').length)) {
          $(this).parent().next().children('a').focus();
        }

        if (($(this).is('ul.sub-menu .dropdown-toggle')) && ($(this).parent().next().children('.dropdown-toggle').length)) {
          $(this).parent().next().children('.dropdown-toggle').focus();
        }

        break;


      case 38: 				// up key
        e.preventDefault();
        e.stopPropagation();

        if ($(this).parent().prev().length) {
          $(this).parent().prev().children('a').focus();
        }
        else {
          $(this).parents('ul').first().prev('.dropdown-toggle.toggled-on').focus();
        }

        if (($(this).is('ul.sub-menu .dropdown-toggle')) && ($(this).parent().prev().children('.dropdown-toggle').length)) {
          $(this).parent().prev().children('.dropdown-toggle').focus();
        }

        break;

    }
  });
}

function newWindowLinks() {
  $("a[target='_blank']").append('<span class="u-sr-only">Opens in new window</span>');
}

/**
 * Decorative SVGs (icons beside labeled controls, dividers, Lottie internals)
 * must be hidden from assistive tech when they have no accessible name.
 */
function markDecorativeSvgs( root = document ) {
  root.querySelectorAll( 'svg' ).forEach( ( svg ) => {
    if (
      svg.hasAttribute( 'aria-hidden' )
      || svg.hasAttribute( 'aria-label' )
      || svg.hasAttribute( 'aria-labelledby' )
      || svg.getAttribute( 'role' ) === 'img'
      || svg.querySelector( ':scope > title' )
    ) {
      return
    }

    svg.setAttribute( 'aria-hidden', 'true' )
    svg.setAttribute( 'focusable', 'false' )
  } )

  root.querySelectorAll( 'lottie-player' ).forEach( ( player ) => {
    // aria-description is poorly supported and often flagged as invalid on custom elements.
    const description = ( player.getAttribute( 'aria-description' )
      || player.getAttribute( 'aria-label' )
      || '' ).trim()
    player.removeAttribute( 'aria-description' )

    const placeholders = [
      'enter some text that describes the animation here, needed for screen readers.',
      'enter some text that describes the animation here',
      'this is a lottie animation',
      'animation',
    ]
    const isPlaceholder = ! description
      || placeholders.includes( description.toLowerCase() )

    if ( isPlaceholder ) {
      player.removeAttribute( 'aria-label' )
      player.removeAttribute( 'role' )
      player.setAttribute( 'aria-hidden', 'true' )
      player.setAttribute( 'focusable', 'false' )
    } else {
      player.removeAttribute( 'aria-hidden' )
      player.setAttribute( 'role', 'img' )
      player.setAttribute( 'aria-label', description )
    }

    player.querySelectorAll( 'svg' ).forEach( ( svg ) => {
      svg.setAttribute( 'aria-hidden', 'true' )
      svg.setAttribute( 'focusable', 'false' )
    } )
  } )
}

/**
 * Labels whose only text is inside visually-hidden children need aria-label
 * for checkers that ignore clipped/sr-only content (e.g. IBM label_content_exists).
 */
function ensureLabelAccessibleNames( root = document ) {
  root.querySelectorAll( 'label' ).forEach( ( label ) => {
    if ( label.hasAttribute( 'aria-label' ) || label.hasAttribute( 'aria-labelledby' ) ) {
      return
    }

    const text = ( label.textContent || '' ).replace( /\s+/g, ' ' ).trim()
    if ( ! text ) {
      return
    }

    const srOnly = label.querySelectorAll( '.u-sr-only, .screen-reader-text, .sr-only' )
    if ( ! srOnly.length ) {
      return
    }

    // Clone and strip sr-only nodes to see if any non-hidden text remains.
    const clone = label.cloneNode( true )
    clone.querySelectorAll( '.u-sr-only, .screen-reader-text, .sr-only' ).forEach( ( el ) => el.remove() )
    const visibleText = ( clone.textContent || '' ).replace( /\s+/g, ' ' ).trim()
    if ( visibleText ) {
      return
    }

    label.setAttribute( 'aria-label', text )
  } )
}

function watchDecorativeSvgs() {
  markDecorativeSvgs()
  ensureLabelAccessibleNames()

  const observer = new MutationObserver( ( mutations ) => {
    mutations.forEach( ( mutation ) => {
      mutation.addedNodes.forEach( ( node ) => {
        if ( node.nodeType !== Node.ELEMENT_NODE ) {
          return
        }
        if ( node.matches?.( 'svg, lottie-player, label' ) || node.querySelector?.( 'svg, lottie-player, label' ) ) {
          markDecorativeSvgs( node )
          ensureLabelAccessibleNames( node )
        }
      } )
    } )
  } )

  observer.observe( document.body, { childList: true, subtree: true } )
}

export default function initA11yFunctions(){
  menuDropdownA11y();
  newWindowLinks();
  watchDecorativeSvgs();
}
